import { IncentiveCampaignValidRegistrationFieldsType } from 'domains/loyalty';

export function getInvalidMemberFields(
  validations?: IncentiveCampaignValidRegistrationFieldsType | null
): string[] {
  const stringfiedValues: Record<string, string> = {
    address: 'Endereço',
    birthdate: 'Data de nascimento',
    email: 'E-mail',
    name: 'Nome',
    phone: 'Número de celular, com 11 dígitos e seguindo o formato: (00) 90000-0000',
  };
  const validationFields = ['name'];
  const result: string[] = [];
  if (validations == null) return result;
  Object.entries(validations).forEach(([key, value]) => {
    if (validationFields.includes(key) && value === false) {
      result.push(stringfiedValues[key]);
    }
  });

  return result;
}
